export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "sportnaloterija-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "sportnaloterija-themeWrapLive" */'./LiveThemeImporter'),
  },
};
